import {REDUCER_NAME as PARENT_REDUCER_NAME} from '../const'
import {REDUCER_NAME} from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const SAVE_STORE_REQUEST = NS + 'SAVE_STORE_REQUEST'

export const SAVE_STORE_SUCCESS = NS + 'SAVE_STORE_SUCCESS'

export const SAVE_STORE_ERROR = NS + 'SAVE_STORE_ERROR'

export const EDIT_STORE = NS + 'EDIT_STORE'

export const VALIDATION_LIST = NS + 'VALIDATION_LIST'

export const CLEAR_STATE = NS + 'CLEAR_STATE'

export const FIND_STORE_REQUEST = NS + 'FIND_STORE_REQUEST'

export const FIND_STORE_SUCCESS = NS + 'FIND_STORE_SUCCESS'

export const FIND_STORE_ERROR = NS + 'FIND_STORE_ERROR'



// WEBPACK FOOTER //
// ./src/modules/store/state/detail/type.js